import { RouteObject } from "react-router-dom";
import {
  JOB,
  JOB_APPLY,
  JOB_CREATE,
  JOB_DETAIL,
  JOB_EDIT,
  JOB_REVIEW,
  JOB_REVIEW_TAB,
  JOB_HIRE,
} from "constants/urls";

export default [
  {
    index: true,
    path: JOB,
    lazy: () => import("modules/job/pages/JobDashboard"),
  },
  {
    path: JOB_DETAIL,
    lazy: () => import("modules/job/pages/JobDetail"),
  },
  {
    path: JOB_CREATE,
    lazy: () => import("modules/job/pages/JobCreateUpdate"),
  },
  {
    path: JOB_EDIT,
    lazy: () => import("modules/job/pages/JobCreateUpdate"),
  },
  {
    path: JOB_APPLY,
    lazy: () => import("modules/job/pages/JobApply"),
  },
  {
    path: JOB_REVIEW,
    lazy: () => import("modules/job/pages/JobReview"),
  },
  {
    path: JOB_REVIEW_TAB,
    lazy: () => import("modules/job/pages/JobReview"),
  },
  {
    path: JOB_HIRE,
    lazy: () => import("modules/job/pages/JobHire"),
  },
] as RouteObject[];
